import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { format } from 'date-fns';
import { last } from 'lodash';
import styled, { css } from 'styled-components';
import { IRecommendationsDB } from 'type/wconcepdb';

import { useGetRecommendationList } from 'hooks/queries/creator';
import useGetSearchParams from 'hooks/useGetSearchParams';
import { BaseChips } from 'shared/chips/style';
import CoreSelect from 'shared/CoreSelect';
import style from 'styles/styled-components/style';

const OrdinalFilter = () => {
	const [groupId] = useGetSearchParams(['recommendationId']);
	const [searchParams, setSearchParams] = useSearchParams();

	const { data } = useGetRecommendationList();

	const optionList = data;

	const convertList = optionList?.map((item) => ({
		value: item.recommendationMonth,
		groupId: item.recommendationId,
		label: format(new Date(item.recommendationMonth), 'yy년 MM월'),
	}));

	useEffect(() => {
		if (!groupId && convertList?.length) {
			const lastOption = last(convertList);
			if (lastOption) {
				searchParams.set('recommendationId', lastOption.groupId.toString());
				setSearchParams(searchParams, { replace: true });
			}
		}
	}, [groupId, convertList]);

	const selectedOption = convertList?.find((item) => {
		if (!groupId) return last(convertList);
		return item.groupId === parseInt(groupId);
	});

	const handleSelectOptionOnChange = (value: string) => {
		const option = convertList?.find((option) => option.label === value);
		if (option) {
			searchParams.set('recommendationId', option.groupId.toString());
			setSearchParams(searchParams, { replace: true });
		}
	};

	return (
		<CoreSelect
			_width="167px"
			_height="32px"
			select_type="box"
			default_quote="전체"
			// 보이는 값은 groupId+월 형식
			option_list={convertList?.map((item) => item.label)}
			selected_option={selectedOption?.label}
			// 선택된 값은 groupId
			setSelectedOption={handleSelectOptionOnChange}
		/>
	);
};

const { Grid } = style;

const AccordionChipWrapper = styled.div<{ _open: boolean }>`
	margin: 8px 0 0 0;
	width: 150px;
	position: absolute;
	${({ theme }) => theme.common.flexStart};
	flex-direction: column;
	border-radius: 8px;

	${({ _open }) =>
		_open &&
		css`
			padding: 8px 0;
			border: 1px solid ${({ theme }) => theme.colors.gray.gray15};
		`}

	background-color: ${({ theme }) => theme.colors.gray.gray_white};
	z-index: 1;

	box-shadow: ${(props) => props.theme.shadow.depth04};
`;

const AccordionChip = styled(BaseChips)`
	width: 100%;
	z-index: 1;

	${({ theme }) => theme.common.flexBetween};
	:hover {
		background-color: transparent;
	}

	${({ selected, theme }) =>
		selected &&
		css`
			border: 2px solid ${theme.colors.uplus.primary50_key};
			background-color: transparent;
			color: ${theme.colors.gray.gray80_text};

			:hover {
				border: 2px solid ${theme.colors.uplus.primary50_key};
				background-color: transparent;
				color: ${theme.colors.gray.gray80_text};
			}
		`}
`;

const AccordionMissionChipWrapper = styled.div`
	width: 90px;
	position: absolute;
	top: -10px;
	left: 158px;
	padding: 8px 0;
	${({ theme }) => theme.common.flexStart};
	flex-direction: column;
	border-radius: 8px;
	border: 1px solid ${({ theme }) => theme.colors.gray.gray15};

	background-color: ${({ theme }) => theme.colors.gray.gray_white};
`;

const AccordionInnerChip = styled(BaseChips)`
	width: 100%;
	height: 48px;
	border: none;
	position: relative;
	border-radius: 0;
	${({ theme }) => theme.typo.body.p};

	transition: 0s;

	border: 1px solid transparent;

	${({ theme }) => theme.common.flexBetween};

	&:hover {
		border: 1px solid transparent;
	}

	${({ selected }) =>
		selected &&
		css`
			color: ${({ theme }) => theme.colors.uplus.primary50_key};
			background-color: ${({ theme }) => theme.colors.uplus.bg10_lighten};

			&:hover {
				color: ${({ theme }) => theme.colors.uplus.primary50_key};
				background-color: ${({ theme }) => theme.colors.uplus.bg10_lighten};
			}
		`}
`;

const IconWrapper = styled.span<{ click_selectbox: boolean }>`
	transform: ${(props) => (props.click_selectbox ? 'rotate(180deg)' : 'rotate(0deg)')};
	transition: 0.2s;
`;

export default OrdinalFilter;
